module.exports = __webpack_public_path__ + "43b2a913b2edaba9ef14cdd1ba9de5ea.svg";